if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const wrapIn = (els, wrapper, wrapperClass = 'js-wrapIn') => {
    if ( els.length > 0 ) {
        els[0].parentNode.insertBefore(wrapper, els[0]);
        els.forEach( el => wrapper.appendChild(el) );
        wrapper.classList.add( wrapperClass, 'js-wrapIn' );
    }
};



(function(){

    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}
	}

    if (document.getElementById('terms_btn')) {
        let btnTerms = document.getElementById('terms_btn');
        let termsInfo = document.getElementById('terms_info');
        let termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
        btnTerms.addEventListener('click', function(e) {
            e.preventDefault();
            termsInfo.classList.toggle('open');
            if (!this.classList.contains('active')) {
                this.classList.add('active');
                termsInfo.style.height = termsInfoHeight + 'px';
            } else {
                this.classList.remove('active');
                termsInfo.style.height = '0px';
            }
        });
    }
    if (document.getElementsByClassName('terms-copy').length > 0) {
        let allTermsFancy = document.getElementsByClassName('js-terms');
        let allTermsLength = allTermsFancy.length;
        for (let j = 0; j < allTermsLength; j++) {
            allTermsFancy[j].addEventListener('click', function(e) {
                e.preventDefault();
                let target = this.getAttribute('href').split('#')[1];
                let wrapHeight = document.getElementById(target).getElementsByClassName('wrap')[0].clientHeight;
                if (!document.getElementById(target).classList.contains('open')) {
                    this.classList.add('active');
                    document.getElementById(target).classList.add('open')
                    document.getElementById(target).style.height = wrapHeight + 'px';
                } else {
                    this.classList.remove('active');
                    document.getElementById(target).classList.remove('open');
                    document.getElementById(target).style.height = '0px'
                }
            })
        }
    }

    //set height for slider Reviews 
    if (document.getElementById('reviews-block')) {
    let reviews = document.getElementById('reviews-block');
    elemento.style.height = '800px';
    console.log(reviews-block)
    }

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    
    $(".fancybox").fancybox();

    setTimeout(function(){
        $("#attraction-category option[value='Universities']").text("West Virginia University");
        $("#attraction-category option[value='Sports & Recreation']").text("Outdoor Recreation");
        $("#id_8_460").attr("name","MGT_Press");
    }, 1500);

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: false
    });

    $('.slider-info-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        draggable: false,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    draggable:true,
                }
            }
        ]
    });

    $('.historical-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        draggable:false,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    draggable:true,
                }
            }
        ]
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        let item = $('.historical-menu-item')[nextSlide];
        $('.historical-menu-item').removeClass('active');
        item.classList.add('active');
    });

    const galleryNormal = $('.gallery-content'),
        gallerySimple = $('.gallery-content--simple')

    if( gallerySimple.length > 0 ) {
        gallerySimple.slick({
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                    }
                }
            ]
        })
    } else {
        galleryNormal.slick({
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 3000,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            accessibility: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        })
    }

    // $('.gallery-content').slick({
    //     arrows: true,
    //     dots: false,
    //     infinite: true,
    //     autoplay: false,
    //     autoplaySpeed: 3000,
    //     speed: 500,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     accessibility: false,
    //     responsive: [
    //         {
    //             breakpoint: 600,
    //             settings: {
    //                 slidesToShow: 1,
    //             }
    //         }
    //     ]
    // });

    $('.specials-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        speed: 700,
        accessibility: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: "unslick"
            }
        ]
    });

    $('.historical-menu-item').click(function(){
        let slideIndex = $(this).data('artwork');
        $(".historical-slides").slick('slickGoTo', parseInt(slideIndex));
    });

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }


    //FAQ
    setTimeout(function(){
        $('.tab-label').each(function(){
            let thisHeightTap = $(this).height() + 40;
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeightTap + 'px'},200);
            if($(this).hasClass('open')){
                $(this).parent().animate({height: thisHeight + 'px'},400);
            }
        });
    }, 400);

    $('.tab-label').click(function(){
        let currentclick = $(this);
        let thisHeightTap = $(this).height() + 40;

        let slideIndex = $(this).data('artwork');
        $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

        if(!currentclick.hasClass('open')){
            $('.tab-label').each(function(){
                if($(this) !== currentclick ){
                    if($(this).hasClass('open')){
                        let thisHeight = $(this).height() + 40;
                        $(this).removeClass('open');
                        $(this).parent().animate({height: thisHeight + 'px'},400);
                    }
                }
            });
            currentclick.addClass('open');
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeight + 'px'},400);
        } else {
            currentclick.removeClass('open');
            currentclick.parent().animate({height: thisHeightTap + 'px'},400);
        }
    });

    /* if( $("#form_id-458").length > 0 ){
        $(".personal, .form-module__field:eq(0), .form-module__field:eq(1), .form-module__field:eq(2), .form-module__field:eq(3)" ).wrapAll( "<div class='wrapper-01'></div>" );
        $(".meetings, .form-module__field:eq(4), .form-module__field:eq(5), .form-module__field:eq(6)" ).wrapAll( "<div class='wrapper-02'></div>" );
    } */
    if ( document.getElementById('form_id-458') ) {
        wrapIn(document.querySelectorAll('#form_id-458 .personal'), document.createElement('div'), 'personal-fieldset');
        wrapIn(document.querySelectorAll('#form_id-458 .event'), document.createElement('div'), 'events-fieldset');
    }

})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

